import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { RestApiModel } from '../../../shared/model/rest-api.model';

import { FormSubmission } from '../model/formSubmission.model';
/**
 * @name SurveyManagementService
 */
@Injectable()
export class SurveyManagementService {
  constructor(private http: HttpClient) {}

  /**
   * Retrieve Forms submission lists for form
   * @returns {Observable<Array<FormSubmission>>}
   */
  getFormSubmissions(formId: number): Observable<Array<FormSubmission>> {
    return this.http
      .get(RestApiModel.PROXY_API_URL + '/formService/formSubmission/' + formId)
      .map((res: Array<FormSubmission>) => {
        return res;
      })
      .catch(err => {
        return throwError(err);
      });
  }
}
